import { VoiceMessage } from "./voice-message";
import { ReadingHeroCards } from "./reading-hero-cards";
import { MessageReactions } from "./reactions";
import { reactionsFor, timeLabel } from "@lunary/app-core/reading-chat-model";
import type { ChatMessage, ChatViewer } from "@lunary/app-core/reading-chat-model";
import styles from "./reading-chat.module.css";

type Props = {
  hero: ChatMessage;
  viewer: ChatViewer;
  topicLabel: string;
  onReact?: (messageId: string, reaction: number | null) => void;
};

export function ReadingHero({ hero, viewer, topicLabel, onReact }: Props) {
  const reactions = reactionsFor(hero, viewer);
  return (
    <section
      className={styles.hero}
      aria-label={hero.kind === "voice" ? "Голосовой разбор" : "Разбор текстом"}
    >
      <div className={styles.heroHead}>
        <span className={styles.eyebrow}>Разбор Людмилы</span>
        <small>{timeLabel(hero.created_at)}</small>
      </div>
      <div className={styles.heroBody}>
        <ReadingHeroCards cards={hero.cards} />
        <div className={styles.heroMain}>
          <div className={styles.heroTitle}>{topicLabel}</div>
          {hero.kind === "voice" ? (
            <VoiceMessage
              id={hero.id}
              src={hero.audio_url}
              durationMs={hero.duration_ms ?? 0}
              peaks={hero.peaks}
              unheard={viewer === "user" && hero.heard_at === null}
              size="hero"
            />
          ) : (
            hero.body && <p className={styles.heroText}>{hero.body}</p>
          )}
        </div>
      </div>
      {hero.kind === "voice" && hero.body && (
        <p className={styles.caption}>{hero.body}</p>
      )}
      <MessageReactions
        inline
        align="start"
        mine={reactions.mine}
        other={reactions.other}
        onChange={onReact ? (next) => onReact(hero.id, next) : undefined}
      />
    </section>
  );
}
